import { render, staticRenderFns } from "./textbook-resources.vue?vue&type=template&id=97a3988a&scoped=true&"
import script from "./textbook-resources.vue?vue&type=script&lang=ts&"
export * from "./textbook-resources.vue?vue&type=script&lang=ts&"
import style0 from "./textbook-resources.vue?vue&type=style&index=0&id=97a3988a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a3988a",
  null
  
)

export default component.exports